import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/LanguageContext';
import siteImageManifest from '../data/siteImageManifest.generated.json';
import { openCookiePreferences } from '../services/cookieConsent';

export default function Footer() {
  const { t } = useI18n();
  const v = typeof siteImageManifest?.generatedAt === 'string' ? siteImageManifest.generatedAt : '';
  const suffix = v ? `?v=${encodeURIComponent(v)}` : '';
  const salesPhone = '+40 722 256 339';
  const secretariatPhone = '+40 21 252 54 53';
  const salesEmail = 'vanzari@youngerkarom.ro';
  const secretariatEmail = 'office@youngerkarom.ro';

  return (
    <footer className="yk-footer">
      <div className="yk-container yk-footerInner">
        <div className="yk-footerBrand">
          <img
            className="yk-footerLogo"
            src={`${process.env.PUBLIC_URL}/brand/yk-logo.png${suffix}`}
            alt={t('common.companyName')}
          />
        </div>
        <div className="yk-footerDetails">
          <div className="yk-footerLine">
            <strong>{t('contact.addressLabel')}:</strong> {t('contact.addressValue')}
          </div>
          <div className="yk-footerLine">
            <strong>{t('contact.salesPhoneLabel')}:</strong>{' '}
            <a href="tel:+40722256339">{salesPhone}</a>
          </div>
          <div className="yk-footerLine">
            <strong>{t('contact.secretariatPhoneLabel')}:</strong>{' '}
            <a href="tel:+40212525453">{secretariatPhone}</a>
          </div>
          <div className="yk-footerLine">
            <strong>{t('contact.salesEmailLabel')}:</strong>{' '}
            <a href={`mailto:${salesEmail}`}>{salesEmail}</a>
          </div>
          <div className="yk-footerLine">
            <strong>{t('contact.secretariatEmailLabel')}:</strong>{' '}
            <a href={`mailto:${secretariatEmail}`}>{secretariatEmail}</a>
          </div>
        </div>
        <div className="yk-footerMetaGroup">
          <div className="yk-footerLinks">
            <Link className="yk-footerLink" to="/politica-confidentialitate">
              {t('legal.privacyPolicy')}
            </Link>
            <Link className="yk-footerLink" to="/politica-cookie-uri">
              {t('legal.cookiePolicy')}
            </Link>
            <button type="button" className="yk-footerLinkBtn" onClick={openCookiePreferences}>
              {t('legal.cookieSettings')}
            </button>
          </div>
          <div className="yk-footerMeta">© {new Date().getFullYear()} {t('common.companyName')}</div>
        </div>
      </div>
    </footer>
  );
}
